import axios from 'axios';

const API_BASE = '/api';

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);

export const groupsAPI = {
  getAll: () => api.get('/groups/'),
  create: (data) => api.post('/groups/create.php', data),
  getById: (id) => api.get(`/groups/show.php?id=${id}`),
  update: (id, data) => api.put(`/groups/update.php?id=${id}`, data),
  delete: (id) => api.delete(`/groups/delete.php?id=${id}`)
};

export const membersAPI = {
  create: (data) => api.post('/members/create.php', data),
  update: (id, data) => api.put(`/members/update.php?id=${id}`, data),
  delete: (id) => api.delete(`/members/delete.php?id=${id}`)
};

export const goalsAPI = {
  getAll: () => api.get('/goals/'),
  getByMember: (memberId) => api.get(`/goals/?member_id=${memberId}`),
  getByGroup: (groupId) => api.get(`/goals/?group_id=${groupId}`),
  create: (data) => api.post('/goals/create.php', data),
  update: (data) => api.put('/goals/update.php', data)
};

export const hotseatAPI = {
  getAll: () => api.get('/hotseats/'),
  getByGroup: (groupId) => api.get(`/hotseats/?group_id=${groupId}`),
  getByMonth: (month) => api.get(`/hotseats/?month=${month}`),
  upsert: (data) => api.post('/hotseats/upsert.php', data),
  delete: (groupId, month) => api.delete(`/hotseats/delete.php?group_id=${groupId}&month=${month}`)
};

export const analyticsAPI = {
  getMeetingsNeedingGoals: (meetingDate) => 
    api.get(`/analytics/meetings-needing-goals.php?meeting_date=${meetingDate}`)
};

export default api;